module.exports = __webpack_public_path__ + "img/20190919155902711.7d1ebca6.jpg";